import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { DocumentService } from '@app/shared/services';
import { CryptoService } from '@app/shared/services/crypto/crypto.services';
import { AnimationOptions } from 'ngx-lottie';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { SecurityKeyDialogComponent } from '../../securitykey/components/security-key-dialog/security-key-dialog.component';

@Component({
  selector: 'ask-security-key-password',
  templateUrl: './ask-security-key-password.component.html',
  styleUrls: ['./ask-security-key-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AskSecurityKeyPasswordComponent implements OnInit, OnDestroy {
  screenWidth: number;
  getAnimationOptions: AnimationOptions = {
    path: 'assets/lottie/lock-basic-new.json',
  };
  iSGetLottieOn = false;
  hintKey = null;
  documentForm: UntypedFormGroup;
  isClick = false;
  security_key;
  showHint = true;
  currentuserId;
  subscription = new Subscription();
  resizeObservable$: Observable<Event>;

  constructor(
    private loginService: LoginStoreEffects,
    @Inject(MAT_DIALOG_DATA) public data,
    private cryptoService: CryptoService,
    private cd: ChangeDetectorRef,
    private _documentService: DocumentService,
    private dialog: MatDialog,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<AskSecurityKeyPasswordComponent>,
    private formBuilder: UntypedFormBuilder
  ) {
    this.getAnimationOptions;
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data) {
          this.currentuserId = state.data.id;
        }
      })
    );
    if (this.data?.isDownloadPopup) {
      this.showHint = false;
    }
    this.documentForm = this.formBuilder.group({
      documentName: ['', Validators.required],
    });
    if (this.data?.vaultFormId) {
      this.subscription.add(
        this.documentService.getSecurityKeyByFormId(this.data.vaultFormId).subscribe((res) => {
          this.hintKey = res['Items'].find((x) => x.sk == this.data.security_key).hint;
          this.security_key = res['Items'].find((x) => x.sk == this.data.security_key);
        })
      );
    } else if (this.data?.currentValutUserId) {
      this.subscription.add(
        this.documentService.getSecurityKeyWidhId(this.data.currentValutUserId).subscribe((res) => {
          this.hintKey = res['Items'].find((x) => x.sk == this.data.security_key).hint;
          this.security_key = res['Items'].find((x) => x.sk == this.data.security_key);
        })
      );
    }
  }

  ViewHint() {
    if (this.hintKey == null) {
      if (this.data?.vaultFormId) {
        this.subscription.add(
          this.documentService.getSecurityKeyByFormId(this.data.vaultFormId).subscribe((res) => {
            this.hintKey = res['Items'][0]['hint'];
            const dialogKeyRef = this.dialog.open(SecurityKeyDialogComponent, {
              data: { securityKey: this.hintKey, isHint: true },
              panelClass: 'security-key-dialog',
            });
          })
        );
      } else {
        this.subscription.add(
          this.documentService.getSecurityKeyWidhId(this.data.currentValutUserId).subscribe((res) => {
            this.hintKey = res['Items'][0]['hint'];
            const dialogKeyRef = this.dialog.open(SecurityKeyDialogComponent, {
              data: { securityKey: this.hintKey, isHint: true },
              panelClass: 'security-key-dialog',
            });
          })
        );
      }
    } else {
      const dialogKeyRef = this.dialog.open(SecurityKeyDialogComponent, {
        data: { securityKey: this.hintKey, isHint: true },
        panelClass: 'security-key-dialog',
      });
    }
  }

  callDownloadFunction() {}
  Verify() {
    if (!this.showHint) {
      this.callDownloadFunction();
    } else {
      this.iSGetLottieOn = true;
      this.cd.detectChanges();
      const data = {
        sk: this.data?.data?.security_key,
        key: this.cryptoService.hashData(this.documentForm.controls.documentName.value),
      };
      this.subscription.add(
        this._documentService.verifySecurityKey(data).subscribe(
          (res) => {
            this.iSGetLottieOn = false;
            this.cd.detectChanges();
            if (res.isValidKey) {
              this.dialogRef.close({ isVerify: true, sk: this.documentForm.controls.documentName.value, security_key: res.security_key });
            } else {
              this.isClick = true;
              this.cd.detectChanges();
              // this.toastr.error("you have entered wrong key.")
            }
          },
          (error) => {
            this.iSGetLottieOn = false;
            this.cd.detectChanges();
          }
        )
      );
    }
  }
  closedialog() {
    this.dialogRef.close({ isVerify: false });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
